<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Home Page</title>
  <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css" rel="stylesheet">
  <link href="https://cdn.jsdelivr.net/npm/animate.css" rel="stylesheet">
  <link rel="stylesheet" href="home-page.component.scss">
</head>

<body>
 <nav class="navbar navbar-expand-lg fixed-top navbar-dark bg-dark">
  <div class="container-fluid">
    <a class="navbar-brand text-white" href="#">COSMO SPORTS</a>
    <button class="navbar-toggler" type="button" (click)="isCollapsed = !isCollapsed">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div [ngClass]="{'collapse navbar-collapse justify-content-end': true, 'show': !isCollapsed}" id="navbarNavDropdown">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a routerLink="/home-page" class="nav-link text-white" routerLinkActive="active">Home</a>
        </li>
        <li class="nav-item">
          <a routerLink="/about-us" class="nav-link text-white" routerLinkActive="active">About Us</a>
        </li>
        <li class="nav-item">
          <a routerLink="/contact-us" class="nav-link text-white" routerLinkActive="active">Contact</a>
        </li>
      </ul>
    </div>
  </div>
</nav>



 <section class="hero">
  <div class="hero-content">
    <h1>Gear Up for Greatness</h1>
    <p>Discover the latest sportswear, equipment, and accessories from top brands. Whether you’re a beginner or a pro — we’ve got what fuels your game.</p>
    
    <div class="mt-4">
      <button class="btn btn-book" routerLink="/contact-us" routerLinkActive="active">SHOP NOW</button>
      <button class="btn btn-learn" routerLink="/about-us" routerLinkActive="active">LEARN MORE</button>
    </div>
  </div>
</section>
  <br>
  <br>

<!-- ------------------------above this home entry view----------------------------- -->



<section class="shop-section text-center">
  <div class="container">
    <h2 class="shop-title">Explore Our Categories</h2>
    <p class="mb-5" style="color: whitesmoke;">Everything you need to power your game and performance.</p>

    <div class="row g-4">
      <div class="col-md-3 col-sm-6">
        <div class="category-card">
          <i class="fa fa-futbol"></i>
          <h5>Football</h5>
          <p style="color: black;">Shop balls, shoes, and kits from top global brands.</p>
        </div>
      </div>

      <div class="col-md-3 col-sm-6">
        <div class="category-card">
          <i class="fa fa-table-tennis"></i>
          <h5>Indoor Games</h5>
          <p style="color: black;"> Table tennis, carrom, and chess gear for home or clubs.</p>
        </div>
      </div>

      <div class="col-md-3 col-sm-6">
        <div class="category-card">
          <i class="fa fa-running"></i>
          <h5>Fitness & Gym</h5>
          <p style="color: black;">Equipment, apparel, and accessories for fitness lovers.</p>
        </div>
      </div>

      <div class="col-md-3 col-sm-6">
        <div class="category-card">
          <i class="fa fa-basketball-ball"></i>
          <h5>Basketball</h5>
          <p style="color: black;">Hoops, balls, and performance shoes built for champions.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ------------------------MAIN CONTENT IN  THE SECTION CATEGORIY---------------------- -->
  <br>
  <div style="flex: 1; height: 2px; background: #ddd; margin: 0 10px; position: relative;">
    <i class="fa fa-rocket"
      style="position: absolute; top: -12px; left: 50%; transform: translateX(-50%); background: #fff; padding: 5px; color: #7d7d7d; border-radius: 50%;"></i>
  </div>
<div class="container my-5">
  <div class="row justify-content-center">
    <div class="col-lg-10">
      <div class="p-5 rounded-4 shadow-lg text-white position-relative" style="background: linear-gradient(135deg, #FF4E50, #F9D423); overflow:hidden;">
        <div style="position:absolute; top:-50px; right:-50px; width:120px; height:120px; background: rgba(255,255,255,0.2); border-radius:50%; transform: rotate(45deg);"></div>
        <div style="position:absolute; bottom:-50px; left:-50px; width:150px; height:150px; background: rgba(255,255,255,0.15); border-radius:50%; transform: rotate(-30deg);"></div>

        <h2 class="fw-bold mb-3" style="font-size:2.2rem;">Gear Up for the Game!</h2>
        <p class="lead mb-4" style="font-size:1.1rem;">
          Find the latest sports gear, apparel, and accessories to elevate your performance.
          From beginners to pros, we’ve got everything you need to stay in the game.
        </p>

        <div class="d-flex justify-content-center flex-wrap gap-3">
          <a routerLink="/contact-us" class="btn btn-outline-light btn-lg px-4 py-2 fw-semibold" style="border-radius:50px;">Contact Us</a>
        </div>
      </div>
    </div>
  </div>
</div>
  <div style="flex: 1; height: 2px; background: #ddd; margin: 0 10px; position: relative;">
    <i class="fa fa-rocket"
      style="position: absolute; top: -12px; left: 50%; transform: translateX(-50%); background: #fff; padding: 5px; color: #7d7d7d; border-radius: 50%;"></i>
  </div>
  <br>
  <h2 style="text-align: center; color: black;">We Provide Best Qualities</h2>
<div class="container my-5">
  <div class="row justify-content-center text-center g-4">
    <div class="col-12 col-sm-6 col-md-4 col-lg-3">
      <img src="../../assets/img/home/basketball.jpg" alt="Basket Ball" class="img-fluid rounded shadow-sm" style="height: 300px; object-fit: cover;">
      <h5 class="mt-2 text-dark">Basket Ball</h5>
    </div>

    <div class="col-12 col-sm-6 col-md-4 col-lg-3">
      <img src="../../assets/img/home/trophic.jpg" alt="Trophy" class="img-fluid rounded shadow-sm" style="height: 300px; object-fit: cover;">
      <h5 class="mt-2 text-dark">Trophy</h5>
    </div>

    <div class="col-12 col-sm-6 col-md-4 col-lg-3">
      <img src="../../assets/img/home/football (2).jpg" alt="FootBall" class="img-fluid rounded shadow-sm" style="height: 300px; object-fit: cover;">
      <h5 class="mt-2 text-dark">FootBall</h5>
    </div>

    <div class="col-12 col-sm-6 col-md-4 col-lg-3">
      <img src="../../assets/img/home/shoe.jpg" alt="Shoe" class="img-fluid rounded shadow-sm" style="height: 300px; object-fit: cover;">
      <h5 class="mt-2 text-dark">Shoe</h5>
    </div>

    <div class="col-12 col-sm-6 col-md-4 col-lg-3">
      <img src="../../assets/img/home/volleyball.jpg" alt="Volley Ball" class="img-fluid rounded shadow-sm" style="height: 300px; object-fit: cover;">
      <h5 class="mt-2 text-dark">Volley Ball</h5>
    </div>
  </div>
</div>
  <br>
  <div style="flex: 1; height: 2px; background: #ddd; margin: 0 10px; position: relative;">
    <i class="fa fa-rocket"
      style="position: absolute; top: -12px; left: 50%; transform: translateX(-50%); background: #fff; padding: 5px; color: #7d7d7d; border-radius: 50%;"></i>
  </div>


  <!-- -------------------------------footer------------------------------------->


<footer class="bg-dark text-white pt-5 pb-3 mt-auto">
  <div class="container">
    <div class="row text-center text-md-start">

      <div class="col-md-4 mb-4 mb-md-0 text-center text-md-start">
        <img src="../../assets/img/home/cosmologo.jpg" alt="Sports Shop Logo" width="80" class="mb-3">
        <h5 class="fw-bold">Gear Up for Your Game!</h5>
        <p class="small">High-quality sports equipment and apparel for every athlete.</p>
      </div>

 
      <div class="col-md-4 mb-4 mb-md-0">
        <h5 class="fw-bold">Quick Links</h5>
        <ul class="list-unstyled">
          <li><a routerLink="/" class="text-white text-decoration-none">Home</a></li>
          <li><a routerLink="/about-us" class="text-white text-decoration-none">About Us</a></li>
          <li><a routerLink="/contact-us" class="text-white text-decoration-none">Contact Us</a></li>
        </ul>
      </div>

      <div class="col-md-4">
        <h5 class="fw-bold">Contact Info</h5>
        <p class="mb-1">ECR ROUNDANA, East Coast Rd, Puthur, Manjakollai, Nagapattinam, Tamil Nadu 611106</p>
        <p class="mb-1">Phone: <a href="tel:+919500706718" class="text-white text-decoration-none">+91 9500706718</a></p>
        <p>Email: <a href="mailto:Cosmosports51@gmail.com" class="text-white text-decoration-none">Cosmosports51@gmail.com</a></p>
      </div>

    </div>

    <hr class="bg-secondary my-4">
    <div class="text-center">
      <p class="mb-1">&copy; 2025 Sports Shop. All rights reserved.</p>
      <p class="mb-0" style="font-size: 12px;">
        Designed by <a href="http://annaasilicontechnology.com/#/" target="_blank" class="text-white text-decoration-none">Annaa Silicon Technology Pvt. Ltd.</a>
      </p>
    </div>
  </div>
</footer>

</body>

</html>